import { render, staticRenderFns } from "./pie-echart.vue?vue&type=template&id=d2662f1e&"
import script from "./pie-echart.vue?vue&type=script&lang=js&"
export * from "./pie-echart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports